import type React from "react";
import {
  Box,
  Typography,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { Facebook, WhatsApp, ChevronRight } from "@mui/icons-material";

interface SharePanelProps {
  onSocialShare: (platform: "facebook" | "whatsapp") => void;
}

const SharePanel: React.FC<SharePanelProps> = ({ onSocialShare }) => {
  const actions = [
    {
      label: "Share on Facebook",
      icon: <Facebook sx={{ fontSize: 18, color: "#1877F2" }} />,
      onClick: () => onSocialShare("facebook"),
    },
    {
      label: "Share on WhatsApp",
      icon: <WhatsApp sx={{ fontSize: 18, color: "#25D366" }} />,
      onClick: () => onSocialShare("whatsapp"),
    },
  ];

  return (
    <Box
      sx={{
        backgroundColor: "#fff",
        borderRadius: "20px",
        p: 2.5,

        boxShadow: "none",
      }}
    >
      <Typography
        variant="h6"
        fontWeight="bold"
        sx={{
          color: "#000000",
          mb: 1.5,
        }}
      >
        Share
      </Typography>

      <List disablePadding>
        {actions.map((action) => (
          <ListItemButton
            key={action.label}
            onClick={action.onClick}
            sx={{
              py: 0.75,
              px: 0,
              backgroundColor: "transparent",
              "&:hover": {
                backgroundColor: "transparent",
                opacity: 0.8,
              },
            }}
          >
            <ListItemIcon
              sx={{
                minWidth: 36,
                width: 36,
                height: 36,
                borderRadius: "50%",
                backgroundColor: "#eff2f5",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                mr: 1.5,
              }}
            >
              {action.icon}
            </ListItemIcon>

            <ListItemText
              primary={action.label}
              primaryTypographyProps={{
                variant: "body2",
                fontWeight: 500,
                color: "#6c757d",
              }}
            />

            <ChevronRight sx={{ color: "#c1c4c9", fontSize: 20 }} />
          </ListItemButton>
        ))}
      </List>
    </Box>
  );
};

export default SharePanel;
